import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { getValidityFromState } from '../Util/from-state.js';
import { focusToTopErrorFieldOf, focusToTopErrorFieldOnScreen } from '../Util/focus-to-top-error-field.js';
import { markFormFieldsTouched } from '../Util/mark-fields-touched.js';

const FormContext = /*#__PURE__*/ React.createContext({});
FormContext.displayName = 'FormContext';
const useFormContext = ()=>{
    const context = React.useContext(FormContext);
    if (!context) {
        throw new Error('No FormContext available. You might still need to wrap the application with the FormProvider component.');
    }
    return context;
};
class Form extends React.Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.initialFormState && nextProps.initialFormState !== this.props.initialFormState && !isEmpty(this.props.initialFormState)) {
            this.setState({
                formState: nextProps.initialFormState
            });
        }
    }
    render() {
        const { className ='form' , name , 'data-t': dataT , showRequiredAndOptionalLabels =true ,  } = this.props;
        const context = {
            name,
            onBlur: this.onBlur,
            onChange: this.onChange,
            onSubmit: this.onSubmit,
            getInitialState: this.getInitialState,
            showRequiredAndOptionalLabels
        };
        return /*#__PURE__*/ React.createElement(FormContext.Provider, {
            value: context
        }, /*#__PURE__*/ React.createElement("form", {
            id: name,
            className: className,
            "data-t": dataT || name,
            "aria-label": this.props['aria-label'],
            onSubmit: this.handleSubmit,
            noValidate: true
        }, this.props.children));
    }
    constructor(props){
        super(props);
        this.handleState = (cb, formControlState)=>{
            this.setState((prevState)=>{
                const newFormState = swcHelpers.objectSpread({}, prevState.formState, {
                    [formControlState.name]: swcHelpers.objectSpread({}, formControlState)
                });
                return {
                    formState: swcHelpers.objectSpread({}, newFormState),
                    formValid: getValidityFromState(newFormState)
                };
            }, cb);
        };
        this.handleChange = ()=>{
            this.props.onChange && this.props.onChange(this.state);
        };
        this.handleBlur = ()=>{
            this.props.onBlur && this.props.onBlur(this.state);
        };
        this.handleSubmit = (e)=>{
            const { onSubmit , showErrorsOnInvalidSubmit =true  } = this.props;
            if (e) {
                e.preventDefault();
            }
            if (e === null || e === void 0 ? void 0 : e.target) {
                focusToTopErrorFieldOf(e.target);
            } else {
                focusToTopErrorFieldOnScreen();
            }
            if (showErrorsOnInvalidSubmit && !this.state.formValid) {
                return this.setState({
                    formState: markFormFieldsTouched(this.state.formState)
                });
            }
            onSubmit && onSubmit(this.state);
        };
        this.onBlur = this.handleState.bind(this, this.handleBlur);
        this.onChange = this.handleState.bind(this, this.handleChange);
        this.onSubmit = this.handleState.bind(this, this.handleSubmit);
        this.getInitialState = (key)=>this.state.formState[key]
        ;
        this.state = {
            formName: props.name,
            formState: props.initialFormState || {},
            formValid: false
        };
    }
}
var Form$1 = Form;

export { FormContext, Form$1 as default, useFormContext };
//# sourceMappingURL=Form.js.map
